/**
 * User-facing UI strings, centralized for two reasons:
 *   1. Future i18n: swap this module's export to an i18next/react-intl-backed
 *      lookup without touching consumers.
 *   2. Consistency: a single place to review and change wording.
 *
 * Labels intentionally avoid technical detail. For example "🔌 Server offline"
 * rather than "EC2 stopped" — the latter would leak hosting infrastructure.
 */
import { ERROR_TYPES } from './errorHandler';

export const ERROR_LABELS = Object.freeze({
  [ERROR_TYPES.AUTH_EXPIRED]:        '🔑 Session expired',
  [ERROR_TYPES.FORBIDDEN]:           '⛔ Forbidden',
  [ERROR_TYPES.SERVER_ERROR]:        '⚠️ Service error',
  [ERROR_TYPES.SERVICE_UNAVAILABLE]: '⚙️ Server starting',
  [ERROR_TYPES.NETWORK_OFFLINE]:     '🔌 Server offline',
  [ERROR_TYPES.UNKNOWN]:             '❓ Unknown error',
});

/**
 * Resolve a label for an error type. Always returns a non-empty string —
 * unknown error types fall back to the generic UNKNOWN label.
 */
export const getErrorLabel = (errorType) =>
  ERROR_LABELS[errorType] || ERROR_LABELS[ERROR_TYPES.UNKNOWN];
